export default __webpack_public_path__ + "static/media/Bloodbeggar Bolts.002150bb.jpg";